import React from 'react';
import { AlertBlock, SpacerVertical } from '@klarna/bubble-ui';
import { TermsAndConditions } from '@/bpc/components/TermsAndConditions';
import { ErrorMessage } from '@/components/ErrorMessage';
export const WithTermsAndConditions = (WrappedComponent) => class extends React.Component {
    constructor(props) {
        super(props);
        const { bpcPayloadWithTerms } = props;
        const { must_agree_terms_and_conditions_before_underwriting: mustAgreeToTerms, terms_and_conditions: termsData = [], } = bpcPayloadWithTerms || {};
        this.state = {
            selectedTerms: [],
            hasTermsToAgree: !!mustAgreeToTerms && !!termsData.length,
        };
        this.onCheckTermsAndConditions = this.onCheckTermsAndConditions.bind(this);
        this.shouldShowTermsAndConditions = this.shouldShowTermsAndConditions.bind(this);
        this.missingTermsValidation = this.missingTermsValidation.bind(this);
        this.onSubmitTermsAndConditions = this.onSubmitTermsAndConditions.bind(this);
    }
    missingTermsValidation() {
        const { bpcPayloadWithTerms } = this.props;
        const { selectedTerms } = this.state;
        const { must_agree_terms_and_conditions_before_underwriting: mustAgreeToTerms, terms_and_conditions: termsData = [], has_agreed_terms_and_conditions: hasAcceptedTerms, } = bpcPayloadWithTerms || {};
        const hasTermsToAgree = !!mustAgreeToTerms && !!termsData.length;
        return (this.shouldShowTermsAndConditions() &&
            ((hasTermsToAgree && selectedTerms.length !== termsData.length) || !!hasAcceptedTerms));
    }
    shouldShowTermsAndConditions() {
        const { hasPreviousGroup, hasNextGroup, bpcPayloadWithTerms } = this.props;
        const { must_agree_terms_and_conditions_before_underwriting: mustAgreeToTerms, } = bpcPayloadWithTerms;
        /**
         * Meaning is a single group
         */
        return !!mustAgreeToTerms && !hasPreviousGroup && !hasNextGroup;
    }
    onCheckTermsAndConditions(termUrl) {
        const { state, setState: unboundSetState } = this;
        const setState = unboundSetState.bind(this);
        return () => {
            const { selectedTerms } = state;
            let updatedTerms = selectedTerms;
            const alreadySelected = selectedTerms.includes(termUrl);
            if (alreadySelected) {
                updatedTerms = updatedTerms.filter(url => url !== termUrl);
            }
            else {
                updatedTerms = [...selectedTerms, termUrl];
            }
            setState({
                selectedTerms: updatedTerms,
            });
        };
    }
    onSubmitTermsAndConditions() {
        const { bpcPayloadWithTerms, submitTermsAndConditions } = this.props;
        const { terms_and_conditions = [] } = bpcPayloadWithTerms || {};
        if (this.missingTermsValidation()) {
            return Promise.reject(new Error('Terms and conditions missing or already approved'));
        }
        return submitTermsAndConditions({ terms_and_conditions });
    }
    render() {
        const { t, bpcPayloadWithTerms } = this.props;
        const { selectedTerms } = this.state;
        const { terms_and_conditions: termsData = [], has_agreed_terms_and_conditions: hasAcceptedTerms, } = bpcPayloadWithTerms || {};
        const shouldShowTermsAndConditions = this.shouldShowTermsAndConditions();
        const enhancedProps = Object.assign(Object.assign({}, this.props), { onSubmitTermsAndConditionsFn: this.onSubmitTermsAndConditions, missingTermsValidation: this.missingTermsValidation(), termsData });
        // Wraps the input component in a container, without mutating it. Good!
        return (React.createElement(WrappedComponent, Object.assign({ TermsAndConditionsComponent: TermsAndConditionsBuilder({
                shouldShowTermsAndConditions,
                termsData,
                selectedTerms,
                hasAcceptedTerms: !!hasAcceptedTerms,
                onCheckTermsAndConditions: this.onCheckTermsAndConditions,
                t,
            }) }, enhancedProps, this.state)));
    }
};
const TermsAndConditionsBuilder = ({ shouldShowTermsAndConditions, termsData, selectedTerms, hasAcceptedTerms, onCheckTermsAndConditions, t, }) => ({ isLoading, ctaClicked, }) => {
    const noTermsAcceptedError = shouldShowTermsAndConditions && ctaClicked && selectedTerms.length !== termsData.length
        ? t('products-fe.errors.noTermsAccepted')
        : undefined;
    return (React.createElement(React.Fragment, null,
        shouldShowTermsAndConditions && (React.createElement(TermsAndConditions, { termsData: termsData, selectedTerms: selectedTerms, hasAcceptedTerms: hasAcceptedTerms, isLoading: isLoading, onChange: onCheckTermsAndConditions, t: t })),
        noTermsAcceptedError && React.createElement(ErrorMessage, { message: noTermsAcceptedError }),
        hasAcceptedTerms && React.createElement(AlertBlock, { content: [t('products-fe.errors.termsAlreadyAccepted')] }),
        termsData.length > 0 && React.createElement(SpacerVertical, { medium: true })));
};
